import { AuthContextProps } from 'oidc-react';
import { createContext } from 'react';

export type AuthContextType = {
    isAuthenticated: boolean;
    userRole: string | null;
    isLoading: boolean;
    auth: AuthContextProps;
};

export const AuthContext = createContext<AuthContextType>({
    isAuthenticated: false,
    userRole: null,
    isLoading: false,
    auth: {} as AuthContextProps,
});
